import type { LogsInitConfiguration } from "@datadog/browser-logs";
import type { RumInitConfiguration } from "@datadog/browser-rum";

// Direct window.DD_LOGS.init callers do not receive these shared options.

export type SessionCookieOptions = Pick<
  LogsInitConfiguration & RumInitConfiguration,
  | "usePartitionedCrossSiteSessionCookie"
  | "useSecureSessionCookie"
  | "trackSessionAcrossSubdomains"
  | "betaEncodeCookieOptions"
>;

export const sessionCookieOptions: SessionCookieOptions = {
  usePartitionedCrossSiteSessionCookie: true,
  trackSessionAcrossSubdomains: true,
  useSecureSessionCookie: false,
  betaEncodeCookieOptions: true,
};
